export default __webpack_public_path__ + "static/media/logo2.dc42c7a3.PNG";